import Cookies from 'js-cookie'

export function getCookie (key) {
  return Cookies.get(key)
}

export function setCookie (key, value) {
  return Cookies.set(key, value)
}

export function removeCookie (key) {
  return Cookies.remove(key)
}

/* 保存用户登陆账号 */
const userKey = 'USER_ACCOUNT'
export function getUser () {
  return Cookies.get(userKey)
}

export function setUser (value) {
  return Cookies.set(userKey, value)
}

export function removeUser () {
  return Cookies.remove(userKey)
}
